import React, { Component } from 'react'
import PropTypes from 'prop-types'

class TableListTd extends Component {
    render() {
        const { align, children, className, fullWidth } = this.props

        const modifier = align === 'center' ?
            'TableListTd--align-center ' :
            (align === 'right' ? 'TableListTd--align-right ' : '')

        const modifier2 = fullWidth && 'TableListTd--fullWidth'

        return (
            <td className={'TableListTd ' + modifier + modifier2 + (className || '')}>
                {children}
            </td>
        )
    }
}

TableListTd.propTypes = {
    align: PropTypes.oneOf(['center', 'right']),
    fullWidth: PropTypes.bool,
}

export default TableListTd
